import {
    post
} from './request'

/** 中心领导列表接口 */
export const getLingdao = data => post('/index/leader_list', data)
/** 中心职责详情 */
export const getZhongxinZhize = data => post('/index/zero_duty', data)


/** 机关处室列表接口 */
export const getJiguanchushi = data => post('/index/office_list', data)
/** 主要职责列表接口 */
export const getZhuyaozhizePage = data => post('/index/duty_list', data)
export const getZhuyaozhizeOne = data => post('/index/duty_detail', data)
/** 直属单位列表接口 */
export const getZhishudanweiPage = data => post('/index/unit_list', data)
export const getZhishudanweiOne = data => post('/index/unit_detail', data)